import { WorkflowStep } from './workflow-step';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { UserDataService } from '../services/user-data.service';
import { LoggedInUserService } from '../../shared/logged-in-user/logged-in-user.service';
import { Injector } from '@angular/core';

export class WorkflowRuntime {
    private _executionCOntext: WorkflowExecutionContext;
    constructor(
        msalService: MsalService,
        broadcastService: MsalBroadcastService,
        userDataService: UserDataService,
        loggedInUserService: LoggedInUserService,
        injector: Injector
    ) {
        this._executionCOntext = new WorkflowExecutionContext(
            msalService,
            broadcastService,
            userDataService,
            loggedInUserService,
            injector
        );
    }

    executeWorkFlowStep(workflowSteps: WorkflowStep[]): Promise<any> {
        let workflowResult = Promise.resolve<any>(null);
        workflowSteps.forEach(workflow => {
            workflowResult = workflowResult.then<any>(workflow(this._executionCOntext));
        });
        return workflowResult.then((result) => {
            return result;
        });
    }
}

export class WorkflowExecutionContext {
    constructor(
        public msalService: MsalService,
        public broadcastService: MsalBroadcastService,
        public userDataService: UserDataService,
        public loggedInUserService: LoggedInUserService,
        public injector: Injector
    ) { }
}
